<style lang="scss">
  .filter-panel {

    .filter-label {
      display: block;
      font-size: 12px;
      color: #909090;
      margin-bottom: 6px;

      &:after {
        content: "";
        width: 100%;
        height: 1px;
        display: block;
        background-color: #ddd;
        margin-bottom: 8px;
      }
    }
    .buttons {
      display: inline-block;
    }
    display: inline-block;
    margin-right: 16px;
    margin-top: 12px;

    .search-input {
      padding: 6px;
      border-radius: 5px;
      border: 1px solid #ddd;

      &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #aaa;
      }
      &::-moz-placeholder { /* Firefox 19+ */
        color: #aaa;
      }
      &:-ms-input-placeholder { /* IE 10+ */
        color: #aaa;
      }
      &:-moz-placeholder { /* Firefox 18- */
        color: #aaa;
      }
    }
  }

  .projects {
    padding-top: 40px;
  }


    .button {
      padding: 6px 12px;
      border: 1px solid #ddd;
      border-radius: 5px;
      background-color: #fff;
      transition: all 0.2s;
      outline-style: none;

      &:active {
        outline-style: none;
      }
      &:hover {
        background-color: #ddd;
        outline-style: none;
      }

      &.-active {
        background-color: #FF6074;
        border-color: #FF6074;
        transition: none;
        color: #fff;
      }
    }
</style>

<template>
  <div>
  <div class="filter-panel">
    <span class="filter-label">客戶</span>
    <div class="buttons">
      <button class="button filter" type="submit" :class="{'-active': this.clientFilter === 'SELF'}" @click="setClientFilter('SELF')">自主案</button>
      <button class="button filter" type="submit" :class="{'-active': this.clientFilter === 'COMMERCIAL'}" @click="setClientFilter('COMMERCIAL')">商業案</button>
    </div>
  </div>

  <div class="filter-panel">
    <span class="filter-label">狀態</span>
    <div class="buttons">
      <button class="button filter" :class="{'-active': this.statusFilter === 'DURING_PROPOSAL'}" @click="setStatusFilter('DURING_PROPOSAL')">提案中</button>
      <button class="button filter" :class="{'-active': this.statusFilter === 'FAILED_PROPOSAL'}" @click="setStatusFilter('FAILED_PROPOSAL')">提案失敗</button>
      <button class="button filter" :class="{'-active': this.statusFilter === 'PROCESSING'}" @click="setStatusFilter('PROCESSING')">進行中</button>
      <button class="button filter" :class="{'-active': this.statusFilter === 'FINISHED'}" @click="setStatusFilter('FINISHED')">已結案</button>
    </div>
  </div>

  <div class="filter-panel">
    <span class="filter-label">類型</span>
    <div class="buttons">
      <button class="button filter" :class="{'-active': this.currentTypeFilter === 'ANIMATION'}" @click="setTypeFilter('ANIMATION')">動畫</button>
      <button class="button filter" :class="{'-active': this.currentTypeFilter === 'LAZY'}" @click="setTypeFilter('LAZY')">懶人包</button>
      <button class="button filter" :class="{'-active': this.currentTypeFilter === 'GRAPHIC'}" @click="setTypeFilter('GRAPHIC')">平面設計</button>
      <button class="button filter" :class="{'-active': this.currentTypeFilter === 'WEBSITE'}" @click="setTypeFilter('WEBSITE')">網站</button>
      <button class="button filter" :class="{'-active': this.currentTypeFilter === 'MIXED'}" @click="setTypeFilter('MIXED')">綜合</button>
      <button class="button filter" :class="{'-active': this.currentTypeFilter === 'OTHER'}" @click="setTypeFilter('OTHER')">其他</button>
    </div>
  </div>

  <div class="filter-panel">
    <span class="filter-label">搜尋</span>
    <div class="buttons">
      <input type="text" class="search-input" v-model="search_input" placeholder="輸工作項目/專案名稱">
    </div>
  </div>
  <div class="projects">
    <div class="" v-for="project in filteredProjects">
      <project-report-single :data="project" :uuid="project.uuid"></project-report-single>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash';
export default {
  props: ['datas', 'project_costs'],
  data() {
    return {
      projects: [],
      otherCosts: [],
      orderType: 'BUDGET',
      orderDesc: true,
      clientFilter: 'COMMERCIAL',
      statusFilter: 'PROCESSING',
      currentTypeFilter: 'NONE',
      emptyFilter: true,
      search_input: ''
    }
  },
  computed: {
    filteredProjects() {
      const clientFiltered = this.projects.filter(project => {
        switch (this.clientFilter) {
          case 'SELF':
            return project.client === '簡訊設計'
          case 'COMMERCIAL':
            return project.client !== '簡訊設計'
          default:
            return true

        }
      })

      const clientStatusFiltered = clientFiltered.filter(project => {
        switch (this.statusFilter) {
          case 'DURING_PROPOSAL':
            return project.status === '提案中'
          case 'FAILED_PROPOSAL':
            return project.status === '提案失敗'
          case 'PROCESSING':
            return project.status === '進行中'
          case 'FINISHED':
            return project.status === '已結案'
          default:
            return true

        }
      })

      const emptyClientStatusFiltered = clientStatusFiltered.filter(project => {
        if (this.emptyFilter) {
          return project.work_hours.length > 0 || project.costs.length > 0
        }
        return true
      })
      let filterProjects = _.filter(emptyClientStatusFiltered, this.filters.typeFilter);
      filterProjects = _.filter(filterProjects, this.filters.nameFilter)

      return _.orderBy(emptyClientStatusFiltered, ['lastFilledAt'], ['desc'])
    }
  },
  methods: {
    setClientFilter(client) {
      if (this.clientFilter === client) {
        this.clientFilter = 'NONE';
      }
      else {
        this.clientFilter = client;
      }
    },
    setStatusFilter(status) {
      if (this.statusFilter === status) {
        this.statusFilter = 'NONE';
      }
      else {
        this.statusFilter = status;
      }
    },
    setTypeFilter(type) {
      if (this.currentTypeFilter === type) {
        this.currentTypeFilter = 'NONE';
      }
      else {
        this.currentTypeFilter = type;
      }
    },
    toggleEmptyFilter() {
      this.emptyFilter = !this.emptyFilter
    }
  },
  filters: {
    typeFilter(projects) {
      return projects.filter(project => {
        switch (this.currentTypeFilter) {
          case 'ANIMATION':
            return project.type === '動畫'
          case 'LAZY':
            return project.type === '懶人包'
          case 'GRAPHIC':
            return project.type === '平面設計'
          case 'WEBSITE':
            return project.type === '網站'
          case 'MIXED':
            return project.type === '綜合'
          case 'OTHER':
            return project.type === '其他'
          default:
            return true
        }
      })
    },
    nameFilter(items) {
      let search = this.search_input
      if (!search || search.length === 0) {
        return items;
      }

      var regex = new RegExp(search, 'i');

      return items.filter((item) => {
        return regex.test(item.name) || regex.test(item.pm_name) || regex.test(item.client);
      });
    },
  },
  mounted() {
    const datas = JSON.parse(this.datas);

    this.projects = datas.map((data) => {
      let newData = data;
      if (data.last_filled_at) {
        data.lastFilledAt = data.last_filled_at.date;
      }
      else {
        data.lastFilledAt = '2017-01-01 00:00:00.000000';
      }

      return data
    });

  }
}
</script>
